import { produce } from 'immer'
import { rules } from './rules'

// type
import {
	ValidatorBodyType,
	FieldType,
	ConditionType,
	UnitResultType,
	ValidatorResultType,
} from './types'
import dayjs from 'dayjs'

const mainValidator = (
	condition: ConditionType,
	body: ValidatorBodyType,
): ValidatorResultType => {
	const result: ValidatorResultType = produce<any>(body, draft => {
		const keyArr: string[] = Object.keys(body)
		keyArr.map((aField: string) => {
			if (condition[aField] !== undefined) {
				const equalWith = condition[aField]['equalsWith'] ?? null
				const newValue: UnitResultType = util.unitValidator({
					condition: condition[aField],
					value: body[aField],
					equalsWith: equalWith === null ? '' : body[equalWith],
				})

				draft[aField] = newValue
			} else {
				delete draft[aField]
			}
		})
	})

	return result
}

const util = {
	unitValidator: ({
		condition = <FieldType>{},
		value = '',
		equalsWith = '',
	}: {
		condition: FieldType
		value: ValidatorBodyType['key']
		equalsWith: ValidatorBodyType['key']
	}): UnitResultType => {
		const invalidRuleArr: FieldType['rules'] = condition.rules
			.filter((aRule: string) => {
				const isValid = /\[/.test(aRule)
					? util.checkParameteredRule(aRule, value)
					: util.checkCommonRule(aRule, value, equalsWith)

				return !isValid
			})
			.map((aRule: string) => aRule.split('[')[0])

		const result: UnitResultType =
			invalidRuleArr.length === 0
				? { isValid: true, message: '' }
				: { isValid: false, message: condition['message'][invalidRuleArr[0]] }

		return result
	},

	checkParameteredRule: (aRule: string, value: ValidatorBodyType['key']) => {
		const matchRuleResult: string[] | null = aRule.match(/\[(.*?)\]/)
		const ruleParams = matchRuleResult !== null ? JSON.parse(matchRuleResult[1]) : ''
		const newRule: string = aRule.split('[')[0]
		const isValid = rules[newRule](value, ruleParams)

		return isValid
	},

	checkCommonRule: (
		aRule: string,
		value: ValidatorBodyType['key'],
		equalsWith: ValidatorBodyType['key'],
	) => {
		const isIncludedRule = Object.keys(rules).includes(aRule)

		if (typeof value !== 'string') {
			value = value.toString()
		}

		if (aRule === 'isDate') {
			if (['', null, undefined].includes(value)) {
				value = dayjs().format('YYYY-MM-DD')
			} else {
				value = dayjs(value).format('YYYY-MM-DD')
			}
		}

		const isValid = !isIncludedRule
			? false
			: aRule === 'equals' || aRule === 'matches'
			? rules[aRule](value, equalsWith)
			: rules[aRule](value)

		return isValid
	},
}

export default mainValidator
